//Dependecies
import React, { useEffect, useState, useCallback } from 'react';
import { Entity, Scene } from 'aframe-react';
import { Spin } from 'antd';
//https://www.youtube.com/watch?v=FFUUhYhxh5Q
//https://www.youtube.com/watch?v=dBWhAGhw7wM
//https://www.npmjs.com/package/react-use-gesture
import 'aframe';
import 'aframe-look-at-component';
import '../../../scripts/e-look-controls';
//Actions
//import { tourWalking } from '../../../store/actions/NotificationsActions';
//Database
import Tours from '../../../databases/tours';


/* 360 PROJECT VIEWER */
const Virtual02 = (props) =>
{
  const { hidehotspots, tourID, tourArray, isMobile } = props;  

  const [fov, setFov] = useState(null);
  const [from, setFrom] = useState('01');
  const [viewangle, setViewangle] = useState('0');  

  const [id, setID] = useState(`${tourID}pano01`);

  const [list01, setList01] = useState();
  const [list02, setList02] = useState();
  const [list03, setList03] = useState();

  const [downTime, setDownTime] = useState(null);

  const [panoLoading, setPanoLoading] = useState(true);

  /* INIT ASPECT RATIO */
  useEffect(() =>
  { 
    const element = document.getElementById('container');

    let aspectRatio = element.clientWidth/element.clientHeight;

    if(aspectRatio > (4/3))
    {
      setFov(90)
    }
    else if(aspectRatio >= 0.6 && aspectRatio <= (4/3))
    {
      setFov(110)
    }
    else  if(aspectRatio < 0.6)
    {
      setFov(120)
    }
  }, []);

  /* RESET TOUR */
  useEffect(() =>
  {
    setList03(null);
    setFrom('01');
    setID(`${tourID}pano01`);
  }, [tourID]);

  const hotspotClick01 = useCallback((e, data) => 
  {
    let upTime = e.timeStamp;

    if(upTime - downTime > 40 && upTime - downTime < 250)
    {
      setList03(null);

      setFrom(data.to);
      setID(`${tourID}pano${data.to}`);
      setViewangle(data.cameraRotation);
    }    
  }, [tourID, downTime]); 

  /* HOTSPOTS */
  useEffect(() =>
  {
    let hotspots = Tours[tourID].hotspots;

    if(!hidehotspots)
    {
      const arrowCoords =
      {
        coord01: 
        {
          position  : '-0.5657 0 0',
          rotation  : '0 0 -45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord02: 
        {
          position  : '0.5657 0 0',
          rotation  : '0 0 45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord03: 
        {
          position  : '-0.5657 0.9534 0',
          rotation  : '0 0 -45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord04: 
        {
          position  : '0.5657 0.9534 0',
          rotation  : '0 0 45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord05: 
        {
          position  : '-0.5657 -1 0',
          rotation  : '0 0 -45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord06: 
        {
          position  : '0.5657 -1 0',
          rotation  : '0 0 45',
          color     : '#d8d9d4',
          height    : 2,
          width     : 0.4,
          opacity   : 1,
        },

        coord07: 
        {
          position  : '-0.5657 0 -.01',
          rotation  : '0 0 -45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,
        },

        coord08: 
        {
          position  : '0.5657 0 -.01',
          rotation  : '0 0 45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,
        },

        coord09: 
        {
          position  : '-0.5657 0.9534 -.01',
          rotation  : '0 0 -45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,
        },

        coord10: 
        {
          position  : '0.5657 0.9534 -.01',
          rotation  : '0 0 45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,
        },

        coord11: 
        {
          position  : '-0.5657 -1 -.01',
          rotation  : '0 0 -45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,
        },

        coord12: 
        {
          position  : '0.5657 -1 -.01',
          rotation  : '0 0 45',
          color     : '#171717',
          height    : 2.1,
          width     : 0.5,
          opacity   : 0.8,        
        },
      };

      let arrow = Object.keys(arrowCoords).map((m1, i) => 
      {
        let data = {...arrowCoords[m1]};
        
        return(
          <Entity
            key         = {i}
            //id          = 'box'
            visible     = 'true'
            geometry    = {{ 
                            primitive   : "plane",
                            height      : data.height,
                            width       : data.width,
                          }}
            position    = {data.position}
            rotation    = {data.rotation}

            material    = {`shader: flat; color: ${data.color}; opacity: ${data.opacity}`}
          />
        )
      });

      let tourHotspots = hotspots.map((m1, i) => 
      {
        if(m1.from === from)
        {
          return(
            <Entity
              key         = {i}
              //id          = 'box'
              visible     = 'true'
              geometry    = {{ 
                              primitive   : "plane",
                              height      : 3,
                              width       : 3,
                            }}
              position    = {m1.hotspotPosition}
              rotation    = {`0 0 0`}

              material    = {`shader: flat; transparent: true; opacity: 0`}

              look-at     = "[camera]"
            >
              <Entity
                key         = {i}
                id          = 'box'
                visible     = 'true'
                geometry    = {{ 
                                primitive   : "plane",
                                height      : 4,
                                width       : 3,
                              }}
                position    = {'0 -1.5 0'}
                rotation    = {`-60 0 0`}

                events      =
                {{
                  click : (e) => hotspotClick01(e, m1),
                }}

                material    = {`shader: flat; transparent: true; opacity: 0`}
              >
                {arrow}
              </Entity>
            
            </Entity>
          );
        }
        else
        {
          return null;
        }
        
      });

      setList01(tourHotspots);
    }
    else
    {
      setList01(null);
    }
  }, [tourID, hidehotspots, from, id, hotspotClick01]);

  /* ALL PANORAMAS */
  useEffect(() =>
  {
    let dataArray = [];

    for (let i = 0; i < tourArray.length; i++) 
    {     
      let tourSelected = tourArray[i];      

      let data = Tours[tourSelected].panoramas;

      if(!data) {continue};

      for(let j = 0; j < Object.keys(data).length; j++)
      {
        let info = data[Object.keys(data)[j]];

        let arrayData =
        {
          id      : `${tourArray[i]}pano${info.pano}`,
          url     : info.url,
        }

        dataArray.push(arrayData);
      }
    };

    let tourPanoramas = Object.keys(dataArray).map((m1, i) => 
    {
      let data = {...dataArray[m1]};

      return(
        <a-assets
          key     = {i}
          timeout = "1000"
          id      = {`pano${i}`}
        >
          <img 
            alt         = 'true' 
            id          = {data.id}
            crossOrigin = 'anonymous'
            src         = {data.url}
            onLoad      = {() => i === parseInt(dataArray.length/5) ? setPanoLoading(false) : null}
          />
        </a-assets>
      );
    });
    
    setList02(tourPanoramas);
  }, [tourArray]);

  /* TRANSITION SPHERE */
  useEffect(() =>
  { 
    let sphere = (
      <Entity
        visible     = 'true'
        geometry    = {{ 
                        primitive   : "sphere",
                        radius      : '3'
                      }}
        position    = {`0 0 0`}
        rotation    = {`0 0 0`}
        scale       = {`1 1 1`}
        material    = {"color: black; side: back; shader: flat"}
        animation   = {"property: material.opacity; from: 1; to: 0; dur: 1500; easing: linear; loop: false; "}
      />
    );

    setList03(sphere);

  }, [tourID, id]);
 
  const onDown = (time) =>
  {
    setDownTime(time);
  }

  return(
    <div
      style = 
      {{
        height : '100vh',
        width : '100vw', 
      }}
      id = 'container'
      onMouseDown = {(e) => onDown(e.timeStamp)} 
    >
      {panoLoading &&
        <div
          className = 'fixed absolute flex w-screen h-screen justify-center items-center flex-col z-[10000] bg-gray-900 bg-opacity-40`'
        >
          <Spin size="large" />
          <span
            className ='flex justify-center mt-4 lg:text-2xl md:text-xl text-white font-semibold'
          >
            SE ESTÁN CARGANDO LOS PANORAMAS
          </span>
        </div>
      }

      <Scene 
        device-orientation-permission-ui = "enabled: false" 
        disable-inspector 
        touchEnabled vr-mode-ui     = "enabled:false;" 
        id = "myEmbeddedScene" 
        embedded
        loading-screen = "dotsColor: white; backgroundColor: black" 
        raycaster = "objects: .raycastable"
      >
         {/* HOTSPOTS ARROWS */}
         <a-assets
          timeout = "1000"
        >
          <img 
            alt         = 'expo-arrows-01' 
            id          = 'expo-arrows-01'
            crossOrigin = 'anonymous'
          />
        </a-assets>

        {list01}
        {list02}
        {list03}

        <Entity
          primitive = "a-sky" 
          height = "1024"
          width = "1024"
          src = {`#${id}`}
        />

        <a-camera
          fov             = {!fov ? '' : fov }
          zoom            = {1}
          position        = "0 1.6 0" 
          wasd-controls   = 'enabled: false' 
          e-look-controls = {`enabled: true; customRot : ${viewangle};  autorotateSpeed: ${isMobile ? '0.001' : '0.0005'};` }
          look-controls   = 'enabled: false'
        >
          <a-entity
            cursor = "rayOrigin: mouse; fuseTimeout: 0;"
            raycaster = "objects: #box"
          />
        </a-camera>    
      </Scene>
    </div>
  )
}

export default Virtual02;